/** @format */

import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Input, Popover, Icon } from '@king-design/react'
import { TriggerRulesProps, LevelValueProps } from '../constants'
import UnitSelect from './UnitSelect'

interface EditLevelProps {
  className?: string
  ruleItem: TriggerRulesProps
  unitOpts: string[]
  onChange: (value: LevelValueProps) => void
}

export const AlertLevelOptionEnum = {
  Critical: '紧急',
  Error: '严重',
  Warning: '警告'
}

const EditLevel: React.FC<EditLevelProps> = ({ className, ruleItem, unitOpts, onChange }) => {
  const { itemKey, compare, units, displayUnits } = ruleItem
  const [levelValue, setLevelValue] = useState<LevelValueProps>(ruleItem.levelValue)
  useEffect(() => {
    setLevelValue(ruleItem.levelValue)
  }, [ruleItem.levelValue])

  return (
    <div className={className}>
      <Popover
        container=".alarm_rule_table"
        slotContent={
          <>
            {Object.entries(AlertLevelOptionEnum).map(([key, label], index) => {
              const item = levelValue[key as keyof LevelValueProps]
              return (
                <div key={index} className="ksc-space lavel_value_item">
                  <p>{label}</p>
                  <Input
                    className={!unitOpts?.length ? 'value_input' : ''}
                    width={itemKey === 'vpc.nat.ipconflict' ? 120 : 230}
                    value={item?.Value || ''}
                    onChangeValue={value => {
                      setLevelValue({
                        ...levelValue,
                        [key]: {
                          ...item,
                          Value: value
                        }
                      })
                    }}
                    slotAppend={
                      itemKey ? (
                        <UnitSelect
                          unitOpts={unitOpts}
                          compare={compare}
                          units={item?.Units || units}
                          displayUnits={item?.DisplayUnits || displayUnits}
                          onChange={value => {
                            setLevelValue({
                              ...levelValue,
                              [key]: {
                                ...item,
                                DisplayUnits: value
                              }
                            })
                          }}
                        />
                      ) : undefined
                    }
                  />
                </div>
              )
            })}
          </>
        }
        onOk={() => {
          onChange && onChange(levelValue)
        }}
      >
        <Icon color="primary" className="k-icon-edit" />
      </Popover>
    </div>
  )
}

export default styled(EditLevel)``
